"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANGUAGE_COOKIE_LIFETIME = exports.CANONICAL_URLS_PROP = exports.LANG_URLS_PROP = void 0;
exports.LANG_URLS_PROP = `_lu`;
exports.CANONICAL_URLS_PROP = `_culs`;
exports.LANGUAGE_COOKIE_LIFETIME = 365 * 24 * 3600; // on year
//# sourceMappingURL=lang.constants.js.map